module.exports = __webpack_public_path__ + "img/wechat-icon.457329bd.svg";